import { trendingItems } from "@/mocks/gossipData";

export default function Trending() {
  return (
    <section id="trending" className="w-full bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
          <div>
            <span className="inline-flex items-center gap-1.5 text-accent-600 text-xs font-semibold tracking-widest">
              <i className="ri-fire-line"></i> REAL-TIME TRENDING
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-extrabold text-foreground-950">娱乐圈实时热搜</h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md">
            根据全网公开讨论热度动态汇总，明星绯闻、恋情曝光、约会实锤与官宣分手最新走向一榜打尽。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-1">
          {trendingItems.map((item) => (
            <article
              key={item.rank}
              className="flex items-center gap-4 py-3 border-b border-background-200 group cursor-pointer"
            >
              <span
                className={`font-heading text-2xl font-black w-10 shrink-0 ${
                  item.rank <= 3 ? "text-primary-600" : "text-foreground-300"
                }`}
              >
                {String(item.rank).padStart(2, "0")}
              </span>
              <div className="flex-1 min-w-0">
                <a href="#gossip" className="text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors font-medium line-clamp-1">
                  {item.title}
                </a>
                <div className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-fire-fill text-primary-500"></i>
                    {item.heat}
                  </span>
                  {item.isHot && (
                    <span className="bg-primary-100 text-primary-700 text-[10px] rounded px-1.5 py-0.5 whitespace-nowrap">爆</span>
                  )}
                </div>
              </div>
              <span className="hidden sm:inline-flex whitespace-nowrap text-[11px] text-accent-700 bg-accent-100 rounded px-2 py-1">
                {item.category}
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}